'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixins = {};
mixins.clickStyles = {
  cursor: 'pointer',
  userSelect: 'none'
};

mixins.disabledClickStyles = {
  cursor: 'default',
  userSelect: 'none'
};

mixins.flexVerticalCenter = {
  display: 'flex',
  alignItems: 'center'
};

mixins.suffixElements = (0, _extends3.default)({}, mixins.flexVerticalCenter, {
  height: '100%',
  paddingLeft: '0.25em',
  paddingRight: '0.25em',
  '&:first-child': {
    paddingRight: '0.125em'
  },
  '&:last-child': {
    paddingLeft: '0.125em'
  },
  '&:last-child:first-child': {
    paddingLeft: '0.25em',
    paddingRight: '0.25em'
  }
});

mixins.iconSize = {
  width: '0.75rem',
  height: '0.75rem'
};

mixins.truncate = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

exports.default = mixins;